import IconAlignLeft from "../../../public/images/align-left.svg";
import IconAlignRight from "../../../public/images/align-right.svg";
import IconAlignCenter from "../../../public/images/align-center.svg";
import Select from "./Select";
import useEditorPanelButtonStore from "../../../store/useEditorPanelButtonStore";
import {useEffect} from "react";
import useObjectEditStore from "../../../store/useObjectEditStore";

const AlignSelect = () => {
  const store = useEditorPanelButtonStore();
  const objectEditStore = useObjectEditStore();

  const variants = [
    {
      type: "left",
      element: <IconAlignLeft className="select__icon"/>,
    },
    {
      type: "center",
      element: <IconAlignCenter className="select__icon"/>,
    },
    {
      type: "right",
      element: <IconAlignRight className="select__icon"/>,
    },
  ];

  useEffect(() => {
    const objectEdit = () => {
      if (objectEditStore.objectEdit.element) {
        objectEditStore.objectEdit.element.style.textAlign = objectEditStore.textAlign;
        return {
          ...objectEditStore.objectEdit,
          align: objectEditStore.textAlign,
        };
      }
      return objectEditStore.objectEdit
    }
    objectEditStore.setObjectEdit(objectEdit());
  }, [objectEditStore.textAlign])

  return (
    <Select tab='align' buttonContent={<IconAlignLeft className="select__icon"/>}>
      <ul className={`align-select__list select__list ${store.isOpenModal !== 'align' ? "select__list-hide" : ""}`}>
        {variants.map(variant =>
          <li key={variant.type} value={variant.type}
              className={`select__variant ${variant.type === objectEditStore.textAlign ? "select__variant-active" :  ""}`}
              onClick={() => objectEditStore.setTextAlign(variant.type)}>
            {variant.element}
          </li>,
        )}
      </ul>
    </Select>
  );
};

export default AlignSelect;
